// extracted by mini-css-extract-plugin
export default {"DatePicker":"style_DatePicker__TxqFF"};